import { ActionSet, createActionSet } from '@futrli/shared-services';

export const CHANGE_PASSWORD: ActionSet = createActionSet('CHANGE_PASSWORD');
